import { defineMessages } from 'react-intl'

export default defineMessages({
  drawerTitle: {
    id: 'editExpenseLineItemDrawerPresenter.drawerTitle',
    defaultMessage: 'Edit expense item',
  },
  cancelButton: {
    id: 'editExpenseLineItemDrawer.cancelButton',
    defaultMessage: 'Cancel',
  },
  saveButton: {
    id: 'editExpenseLineItemDrawer.saveButton',
    defaultMessage: 'Save',
  },
})
